<template>
	<div class="current-box">
		<div class="current">
			<div class="title">그레이트프로 프로젝트 참여 현황</div>
			<div class="count_list"><p>◆ 참여건수</p><span class="count">{{pronPrjInfo.totCnt}}</span><span class="percent"></span></div>
			<div class="count_list"><p>◆ 완료건수</p><span class="count">{{pronPrjInfo.endCnt}}</span><span class="percent">{{pronPrjInfo.endPer}}</span></div>
			<div class="count_list"><p>◆ 이탈건수</p><span class="count leave">{{pronPrjInfo.midWithdrawalCnt}}</span><span class="percent leave">{{pronPrjInfo.midWithdrawalPer}}</span></div>
		</div>
		<div class="cp_count">
			<div class="title">이력서 참여 기간별 프로젝트 완료건수</div>
			<div class="standard"><p>참여기간 (완료기준)</p><p>단위 : 개월이상 / 건</p></div>
			<div class="month-box">
				<div class="month">0</div>	
				<div class="month">3</div>
				<div class="month">6</div>
				<div class="month">9</div>
				<div class="month">12</div>
				<div class="month">24</div>
			</div>
			<div class="count-box">
				<div class="count">{{resPrjInfo.zreMth}}건</div>
				<div class="count">{{resPrjInfo.trdMth}}건</div>
				<div class="count">{{resPrjInfo.sthMth}}건</div>
				<div class="count">{{resPrjInfo.nthMth}}건</div>
				<div class="count">{{resPrjInfo.twvMth}}건</div>
				<div class="count">{{resPrjInfo.tthMth}}건</div>
			</div>
		</div>
		<!-- 구분선 추가 -->
		<div class="divider"></div>	
		<div class="core-competency">
			<div class="title">관리자 선정 핵심역량</div>
			<div class="subtitle">※ 최대 10개까지 등록 가능</div>
			<!-- 검색창과 추가 버튼 추가 -->
			<div class="search-box2">
      			<input v-model="keyword" @keyup.enter="addKeyword" type="text" placeholder="키워드를 입력해주세요" :disabled="isSubmitted">
      			<img v-if="!isSubmitted" src="/images/admin/btn_add_new.png" @click="addKeyword" class="search_btn">
					<img v-if="!isSubmitted" src="/images/admin/cf_save_btn.png" @click="saveKeywords" class="submit_btn">
					<img v-if="isSubmitted" src="/images/admin/cf_modify_btn.png" @click="modifyKeywords" class="modify_btn">
    		</div>
			<div class="keyword-list">
      			<div v-for="(item, index) in keywords" :key="index" class="keyword-item">
        			<span class="keyword-text">{{ item }}</span>
        			<button v-if="!isSubmitted" class="remove_btn" @click="removeKeyword(index)">X</button>
      			</div>
    		</div>
		</div>
	</div>
</template>

<script>
export default {
	props:{
		tecMberSeq : {}
	},
	data() {
		return {
			techMberSeq : this.tecMberSeq || '',
			keyword: '',
			keywords: [],
			pronPrjInfo : {},
			resPrjInfo : {},
			isSubmitted: false,
		}
	},

	mounted() {
		if(this.techMberSeq != '') {
			this.getTecPrjBrif();
			this.getExistingKeywords();
		}
	},

	methods : {
		getTecPrjBrif() {
			this.$.httpPost('/api/mem/prf/getTecPrjBrif', {techMberSeq : this.techMberSeq})
				.then(res => {
					this.pronPrjInfo = res.data.pronPrjInfo;
					this.resPrjInfo = res.data.resPrjInfo;
				})
		},
		getExistingKeywords() {
			this.$.httpPost('/api/mem/prf/getExistingKeywords', {
				techMberSeq: this.techMberSeq
			})
			.then(res => {
				if (res.data && res.data.keywords) {
					// 콤마로 구분된 문자열을 배열로 변환하고 빈 문자열 제거
					this.keywords = res.data.keywords.split(',').filter(keyword => keyword.trim() !== '');
					if (this.keywords.length > 0) {
						this.isSubmitted = true;
					}
				}
			})
			.catch(error => {
				console.error("키워드 조회 실패", error);
			});
		},
		saveKeywords() {
        // 입력받은 키워드를 단순히 this.keywords 배열에 저장
        this.keywords = this.keywords || [];  // this.keywords가 정의되지 않았을 경우 빈 배열로 초기화
        // getAdmMainTech 호출
        this.getAdmMainTech();
        this.isSubmitted = true;
    	},
		
    	getAdmMainTech() {
        this.$.httpPost('/api/mem/prf/getAdmMainTech', {
            techMberSeq: this.techMberSeq,  // 사용자 ID
            keywords: this.keywords         // 핵심역량 키워드 배열
        })
            .then(() => {
                // console.log("업데이트 성공", res);
                // 서버로 키워드 전송 후 성공적으로 업데이트되면 알림 띄우기
                alert('키워드가 저장되었습니다.');
            })
            .catch(error => {
                console.error("업데이트 실패", error);
            });
    	},
		addKeyword() {
      		if (this.keyword && this.keywords.length < 10) {
        		this.keywords.push(this.keyword);
        		this.keyword = ''; // 입력창 초기화
      		} else if (this.keywords.length >= 10) {
        		alert('등록 가능 개수를 초과하였습니다.');
      		}
    	},
		removeKeyword(index) {
			if (confirm("삭제하시겠습니까?")) {
				this.keywords.splice(index, 1);
			}
			
		},
		modifyKeywords() {
			this.isSubmitted = false;
			this.keyword = '';
		}
    }
};
</script>
<style scoped>
</style>